import config from '../config';
import aaveSwapABI from './json/aave/swap';
import aaveV3SwapABI from './json/avax-aavev3/swap';
import paaveRewardsabi from './json/paave/rewards';
import atriCryptoSwap from './json/atricrypto/swap';
import atriCryptoZap from './json/atricrypto/zap';
import atriCrypto2Swap from './json/atricrypto2/swap';
import atriCrypto2Zap from './json/atricrypto2/zap';
import renSwapABI from './json/ren-polygon/swap';
import atriCrypto3Swap from './json/atricrypto2/swap';
import atriCrypto3Zap from './json/atricrypto2/zap';


import Plain2Basic from './json/factory-v2/Plain2Basic';
import Plain2BasicEMA from './json/factory-v2/Plain2BasicEMA';
import Plain2Balances from './json/factory-v2/Plain2Balances';
import Plain2ETH from './json/factory-v2/Plain2ETH';
import Plain2ETHEMA from './json/factory-v2/Plain2ETHEMA';
import Plain2Optimized from './json/factory-v2/Plain2Optimized';
import Plain3Basic from './json/factory-v2/Plain3Basic';
import Plain3Balances from './json/factory-v2/Plain3Balances';
import Plain3ETH from './json/factory-v2/Plain3ETH';
import Plain3Optimized from './json/factory-v2/Plain3Optimized';
import Plain4Basic from './json/factory-v2/Plain4Basic';
import Plain4Balances from './json/factory-v2/Plain4Balances';
import Plain4ETH from './json/factory-v2/Plain4ETH';
import Plain4Optimized from './json/factory-v2/Plain4Optimized';
import DepositZapFantom from './json/factory-v2/DepositZapFantom';
import MetaUSD from './json/factory-v2/MetaUSD';
import MetaUSDBalances from './json/factory-v2/MetaUSDBalances';
import MetaBTC from './json/factory-v2/MetaBTC';
import MetaBTCBalances from './json/factory-v2/MetaBTCBalances';

const infura_url = config.rpcUrl;

//rinkeby multicall 0x0ae6578785868f88478B6bCe8227d6F85703092b
const multicall_address = '0xa00FB557AA68d2e98A830642DBbFA534E8512E5f';

const poolsData = {
    aave: {
        N_COINS: 3,
        is_aave: true,
        coin_precisions: [1e18, 1e6, 1e6],
        wrapped_precisions: [1e18, 1e6, 1e6],
        use_lending: [false, false, false],
        tethered: [false, false, true],
        is_plain: [false, false, false],
        swap_address: '0x7f90122BF0700F9E7e1F688fe926940E8839F353',
        token_address: '0x1337BedC9D22ecbe766dF105c9623922A27963EC',
        gauge_address: '0x5B5CFE992AdAC0C9D48E05854B2d91C73a003858',
        underlying_coins: [
            '0xd586E7F844cEa2F87f50152665BCbc2C279D8d70',
            '0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664',
            '0xc7198437980c041c805A1EDcbA50c1Ce5db95118',
        ],
        coins: [
            '0x47AFa96Cdc9fAb46904A55a6ad4bf6660B53c38a',
            '0x46A51127C3ce23fb7AB1DE06226147F446e4a857',
            '0x532E6537FEA298397212F09A61e03311686f548e',
        ],
        swap_abi: aaveSwapABI,
        sCurveRewards_abi: paaveRewardsabi,
        sCurveRewards_address: '0xB504b6EB06760019801a91B451d3f7BD9f027fC9',
        reward_token: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
    },
    ren: {
        N_COINS: 2,
        is_aave: true,
        coin_precisions: [1e8, 1e8],
        wrapped_precisions: [1e8, 1e8],
        use_lending: [true, false],
        tethered: [false, false],
        is_plain: [false, true],
        swap_address: '0x16a7DA911A4DD1d83F3fF066fE28F3C792C50d90',
        token_address: '0xC2b1DF84112619D190193E48148000e3990Bf627',
        gauge_address: '0x0f9cb53Ebe405d49A0bbdBD291A65Ff571bC83e1',
        underlying_coins: [
            '0x50b7545627a5162F82A992c33b87aDc75187B218',
            '0xDBf31dF14B66535aF65AaC99C32e9eA844e14501',
        ],
        coins: [
          '0x686bEF2417b6Dc32C50a3cBfbCC3bb60E1e9a15D',
          '0xDBf31dF14B66535aF65AaC99C32e9eA844e14501',
        ],
        swap_abi: renSwapABI,
        sCurveRewards_address: '0x75D05190f35567e79012c2F0a02330D3Ed8a1F74',
        reward_token: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
    },
    atricrypto: {
        swap_abi: atriCrypto3Swap,
        deposit_abi: atriCrypto3Zap,
        N_COINS: 5,
        REAL_COINS: 3, //cause this is a fake plain pool
        coin_precisions: [1e18, 1e6, 1e6, 1e8, 1e18],
        wrapped_precisions: [1e18, 1e8, 1e18],
        real_precisions: [1e18, 1e8, 1e18],
        tethered: [false, false, false, false, false],
        use_lending: [false, false, false, false, false],
        is_plain: [true, true, true, true, true],
        swap_address: '0xB755B949C126C04e0348DD881a5cF55d424742B2',
        token_address: '0x1daB6560494B04473A0BE3E7D83CF3Fdf3a51828',
        gauge_address: '0x445FE580eF8d70FF569aB36e80c647af338db351',
        deposit_address: '0x58e57cA18B7A47112b877E31929798Cd3D703b0f',
        pool_type: 'crypto',
        base_pool: 'aave',
        underlying_coins: [
          '0xd586E7F844cEa2F87f50152665BCbc2C279D8d70', //DAI
          '0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664', // USDC
          '0xc7198437980c041c805A1EDcbA50c1Ce5db95118', //usdt
          '0x50b7545627a5162F82A992c33b87aDc75187B218', //WBTC
          '0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB', //WETH
        ],
        coins: [
          '0xd586E7F844cEa2F87f50152665BCbc2C279D8d70', //DAI
          '0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664', // USDC
          '0xc7198437980c041c805A1EDcbA50c1Ce5db95118', //usdt
          '0x50b7545627a5162F82A992c33b87aDc75187B218', //WBTC
          '0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB', //WETH
        ],
        sCurveRewards_address: '0xa05E565cA0a103FcD999c7A7b8de7Bd15D5f6505',
        reward_token: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
    },
    aaveV3: {
        N_COINS: 3,
        is_aave: true,
        coin_precisions: [1e18, 1e6, 1e6],
        wrapped_precisions: [1e18, 1e6, 1e6],
        use_lending: [false, false, false],
        tethered: [false, false, true],
        is_plain: [false, false, false],
        swap_address: '0xD2AcAe14ae2ee0f6557aC6C6D0e407a92C36214b',
        token_address: '0x5bE26703a658c332CE612eAe3A497059dA98394a',
        gauge_address: '0x55f9Ba282c39793DB29C68F8f113fC97D23a6445',
        underlying_coins: [
            '0xd586E7F844cEa2F87f50152665BCbc2C279D8d70',
            '0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664',
            '0xc7198437980c041c805A1EDcbA50c1Ce5db95118',
        ],
        coins: [
            '0x82E64f49Ed5EC1bC6e43DAD4FC8Af9bb3A2312EE',
            '0x625E7708f30cA75bfd92586e17077590C60eb4cD',
            '0x6ab707Aca953eDAeFBc4fD23bA73294241490620',
        ],
        swap_abi: aaveV3SwapABI,
        // sCurveRewards_abi: paaveRewardsabi,
        // sCurveRewards_address: '0xB504b6EB06760019801a91B451d3f7BD9f027fC9',
        // reward_token: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
    },
};


const factoryPoolDataSkeleton = {
    swap_abi: aaveSwapABI,
    N_COINS: 2, // to fill and replace w/ null in skeleton
    coin_precisions: [1e18, 1e18], // to fill and replace w/ null in skeleton
    wrapped_precisions: [1e18, 1e18], // to fill and replace w/ null in skeleton
    tethered: [false, false], // to fill and replace w/ null in skeleton
    use_lending: [false, false], // to fill and replace w/ null in skeleton
    is_plain: [true, true], // to fill and replace w/ null in skeleton
    swap_address: '0x445FE580eF8d70FF569aB36e80c647af338db351', // to fill and replace w/ null in skeleton
    token_address: '0xE7a24EF0C5e95Ffb0f6684b813A78F2a3AD7D171', // to fill and replace w/ null in skeleton
    gauge_address: '0x445FE580eF8d70FF569aB36e80c647af338db351', // Fake pool address to prevent old multicalls from reverting
    underlying_coins: [ // to fill and replace w/ null in skeleton
        '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
        '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490',
    ],
    coins: [ // to fill and replace w/ null in skeleton
        '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
        '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490',
    ],
    deposit_abi: DepositZapFantom,
    deposit_address: '0xA79828DF1850E8a3A3064576f380D90aECDD3359',
    is_meta: true,
    base_pool: 'aave', // to fill and replace w/ null in skeleton
    meta_N: 5, // to fill and replace w/ null in skeleton
    meta_precisions: [1e18, 1e18, 1e18, 1e6, 1e6], // to fill and replace w/ null in skeleton
    meta_coin_precisions: [1e18, 1e18, 1e6, 1e6], // to fill and replace w/ null in skeleton
    meta_wrapped_precisions: [1e18, 1e18], // to fill and replace w/ null in skeleton
    meta_coins: [ // to fill and replace w/ null in skeleton
        '0x6B175474E89094C44Da98b954EedeAC495271d0F',
        '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
        '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    ],
    all_coins: [ // to fill and replace w/ null in skeleton
        '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
        '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490',
        '0x6B175474E89094C44Da98b954EedeAC495271d0F',
        '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
        '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    ],
    is_factory: true,
    sCurveRewards_abi: undefined,
    sCurveRewards_address: undefined,
    reward_token: undefined,
};

export {
    infura_url,
    multicall_address,
    poolsData,
    factoryPoolDataSkeleton,
    Plain2Basic,
    Plain2BasicEMA,
    Plain2Balances,
    Plain2ETH,
    Plain2ETHEMA,
    Plain2Optimized,
    Plain3Basic,
    Plain3Balances,
    Plain3ETH,
    Plain3Optimized,
    Plain4Basic,
    Plain4Balances,
    Plain4ETH,
    Plain4Optimized,
    MetaUSD,
    MetaUSDBalances,
    MetaBTC,
    MetaBTCBalances,
};
